import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { PareceresListWrapper } from './pareceres-list/PareceresList'
import { Permission } from '../../../../_metronic/helpers'
import { useAuth } from '../../auth'

const PareceresPage = () => {
  const { t } = useT()
  const { currentUser } = useAuth()
  // "Pareceres da equipe" é do grupo SOLICITANTE (acompanhar a interconsulta de um colega que saiu
  // do plantão) e do SUPER_ADMIN. Médico e demais perfis veem só as próprias solicitações.
  const veEquipe = [Permission.Solicitante, Permission.SuperAdmin].includes(
    currentUser?.grupo?.nome as Permission
  )
  const titulo = <PageTitle description={t('pagina.pareceres.descricao')}>Pareceres</PageTitle>

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              {titulo}
              <PareceresListWrapper />
            </>
          }
        />
        <Route
          path='equipe'
          element={
            veEquipe ? (
              <>
                <PageTitle description={t('pagina.pareceres_equipe.descricao')}>
                  {t('menu.nav.interconsulta_equipe')}
                </PageTitle>
                <PareceresListWrapper escopo='equipe' />
              </>
            ) : (
              <Navigate to='/apps/pareceres' replace />
            )
          }
        />
        <Route
          path=':protocolo'
          element={
            <>
              {titulo}
              <PareceresListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default PareceresPage
